import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Returns [selectedCompany, setSelectedCompany] that follows the globally-active
 * company (set by the TopBar company switcher / on login). Pages should use this
 * hook instead of `useState('')` so a TopBar switch "just works" page-wide.
 */
export function useActiveCompany() {
  const { activeCompanyId, user } = useAuth();

  const getInitialCompany = () => {
    if (activeCompanyId) return activeCompanyId;
    if (user?.active_company_id) return user.active_company_id;
    if (user?.company_id) return user.company_id;
    if (user?.tenant_id) return user.tenant_id;
    try {
      const stored = localStorage.getItem('selectedCompany');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.id || parsed?.company_id) return parsed.id || parsed.company_id;
      }
    } catch { /* ignore */ }
    return '';
  };

  const [selectedCompany, setSelectedCompany] = useState(getInitialCompany);

  useEffect(() => {
    const effective = activeCompanyId || user?.active_company_id || user?.company_id || user?.tenant_id;
    if (effective) {
      setSelectedCompany(effective);
    }
  }, [activeCompanyId, user?.active_company_id, user?.company_id, user?.tenant_id]);

  return [selectedCompany, setSelectedCompany];
}

export default useActiveCompany;
